import { useEffect, useState } from "react";
import axios from "axios";
import "./PaymentStatus.css";

const PAYMENT_STATUS_URL = "https://users.mpdatahub.com/api/omniware/status";

const PaymentStatus = () => {
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const controller = new AbortController();

    const checkPaymentStatus = async () => {
      try {
        const response = await axios.get(PAYMENT_STATUS_URL, {
          signal: controller.signal,
        });

        const records = response.data?.data;
        console.log("Payment Status Response:", records);

        if (!Array.isArray(records) || records.length === 0) {
          setStatus("error");
          return;
        }

        // Take the latest record (or first — adjust to your API's ordering)
        const latest = records[records.length - 1];
        const transactionStatus = (latest.status || "").toLowerCase();
        console.log("Transaction Status:", transactionStatus);

        if (transactionStatus === "success") {
          setStatus("success");
        } else if (transactionStatus === "failed") {
          setStatus("failed");
        } else {
          setStatus("error");
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          setStatus("error");
        }
      }
    };

    checkPaymentStatus();

    return () => {
      controller.abort();
    };
  }, []);

  const handleExit = () => {
    // Mimic the back gesture: return to the app that opened this page
    if (window.history.length > 1) {
      window.history.back();
    } else {
      // Fallback if there's no history (e.g., deep link / fresh tab)
      window.close();
    }
  };

  const messages = {
    loading: "Checking transaction status...",
    success: "TRANSACTION SUCCESS",
    failed: "TRANSACTION FAILED",
    error: "Unable to verify transaction status. Please try again.",
  };

  return (
    <main className="payment-status-page" aria-live="polite">
      <h1>{messages[status]}</h1>
      {status === "success" && <p>Your transaction was successful.</p>}
      {/* {status === "success" && (
        <button type="button" className="exit-button" onClick={handleExit}>
          Return to App
        </button>
      )} */}
    </main>
  );
};

export default PaymentStatus;
